<template>
	<div class="tcp-page">
		<section class="tcp-section tcp-thanks" v-if="order">
			<p class="tcp-kicker">Order received</p>
			<h1>Thank you</h1>
			<p>Your order <strong>{{ order.code }}</strong> is now processing.</p>
			<p class="tcp-price">{{ money(order.total) }}</p>
			<ul v-if="order.items && order.items.length">
				<li v-for="item in order.items" :key="item.id">
					{{ item.quantity }} × {{ item.product_name }}
				</li>
			</ul>
			<router-link to="/shop" class="tcp-btn">Continue shopping</router-link>
		</section>
		<section v-else class="tcp-section">
			<p class="tcp-empty">No recent order to show.</p>
			<router-link to="/shop" class="tcp-btn">Back to shop</router-link>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			order: null
		}
	},
	methods: {
		money(value) {
			return '$' + Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
		}
	},
	mounted() {
		try {
			this.order = JSON.parse(sessionStorage.getItem('tcp_last_order') || 'null')
		} catch (e) {
			this.order = null
		}
	}
}
</script>
